module.exports = __webpack_public_path__ + "static/img/bg_low1@2x.a33ba08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_low1@2x.png
// module id = 5hzv
// module chunks = 1